import React, { ComponentType, useCallback } from 'react';
import { defineMessages, InjectedIntlProps, injectIntl } from 'react-intl';
import { useHistory, useLocation } from 'react-router-dom';

import { ROUTE_NOTIFICATIONS } from '../../../../constants/routes';
import NavPrimaryMenuButton from '../NavPrimaryMenuButton';

const NavFullPageNotificationsButton: ComponentType<InjectedIntlProps> = props => {
  const { intl } = props;
  const history = useHistory();
  const location = useLocation();
  const handleOnClick = useCallback(() => history.push(ROUTE_NOTIFICATIONS), [history]);

  return (
    <NavPrimaryMenuButton handleOnClick={handleOnClick} isHighlighted={location.pathname === ROUTE_NOTIFICATIONS}>
      {intl.formatMessage(messages.homeButton)}
    </NavPrimaryMenuButton>
  );
};

export default injectIntl(NavFullPageNotificationsButton);

const messages = defineMessages({
  homeButton: {
    defaultMessage: 'Notifications',
    description: 'Button on navigation bar which takes you to full page notifications when clicked',
    id: 'uchi.nav.fullPageNotificationsButton',
  },
});
